import React, { useEffect } from 'react';

const OAuthComplete: React.FC = () => {
  useEffect(() => {
    try {
      // Mark in localStorage for storage event fallback
      localStorage.setItem('youtube-connected', Date.now().toString());
    } catch {}
    try {
      // Notify opener if available
      if (window.opener && typeof window.opener.postMessage === 'function') {
        window.opener.postMessage({ type: 'youtube:connected' }, '*');
      }
    } catch {}
    // Attempt to close
    try { window.close(); } catch {}
    // Fallback: redirect to dashboard
    const t = setTimeout(() => { window.location.replace('/dashboard?youtube=connected'); }, 800);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center p-8 text-center">
      <div>
        <h1 className="text-2xl font-semibold mb-4">YouTube Connected</h1>
        <p className="text-gray-600">You can close this window. If it doesn't close automatically, <a className="text-blue-600 underline" href="/dashboard">click here</a>.</p>
      </div>
    </div>
  );
};

export default OAuthComplete;